module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="l-device-situation">\n\n				<div class="l-device-situation__overview">\n					<ul class="l-device-situation-overview__list">\n\n						';
 if (obj.situation.address) { 
__p+='\n						<li class="l-device-situation-overview__item">\n							'+
((__t=( obj.situation.address ))==null?'':__t)+
'\n						</li>\n						';
 } 
__p+='\n						<li class="l-device-situation-overview__item situation__floor">\n							<div class="label">Floor</div>\n							<div class="value floor__icon">0</span></div>\n						</li>\n						';
 if (obj.situation.image) { 
__p+='\n						<li class="l-device-situation-overview__item situation__picture">\n						<div class="label">Situation picture</div>\n						<div class="value">\n							<img src="'+
((__t=( obj.situation.image ))==null?'':__t)+
'"/>\n						</div>\n						</li>\n						';
 } 
__p+='\n						';
 if (obj.situation.description) { 
__p+='\n						<li class="l-device-situation-overview__item situation__description">\n							<div class="label">Description</div>\n							<div class="value">\n							'+
((__t=( obj.situation.description ))==null?'':__t)+
'\n							</div>\n						</li>\n						';
 } 
__p+='\n						';
 if (hasAssetData()) { 
__p+='\n						<li class="l-device-situation-overview__item situation__description">\n							<div class="label">Asset data</div>\n							<div class="value">\n								<div class="m-simple-table">\n									';
 _.each(getAssetData(), function(option, optionKey) { 
__p+='\n										<div><span>'+
((__t=( option.key ))==null?'':__t)+
'</span><span>'+
((__t=( option.value ))==null?'':__t)+
'</span></div>\n									';
 }) 
__p+='\n								</div>\n							</div>\n						</li>\n						';
 } 
__p+='\n					</ul>\n\n				</div>\n				<div class="l-device-situation__map">\n					<div id="situationMap"></div>\n				</div>\n\n			</div>\n</div>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./js/modules/device-situation/show/templates/layout.html
// module id = 424
// module chunks = 0